import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

// Shared IQAC stub factory
function IQACPage({ title, breadcrumb, subtitle, content }) {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › IQAC › {breadcrumb}</p>
                <h1>{title}</h1>
                <p>{subtitle}</p>
            </div>
            <div className="page-content">{content}</div>
            <Footer />
        </div>
    );
}

const noteStyle = {
    padding: '0.7rem 1.1rem', background: '#f0faf4',
    border: '1px solid #b7e4c7', borderRadius: '8px',
    color: '#1a3c5e', fontSize: '0.9rem', lineHeight: 1.7, marginBottom: '1rem'
};

// ── SSR
export function IQACSSR() {
    return <IQACPage
        title="Self Study Report (SSR)"
        breadcrumb="SSR"
        subtitle="NAAC Self Study Report submitted by the college."
        content={
            <div className="info-card">
                <h2>NAAC Self Study Report (SSR)</h2>
                <p>The Self Study Report (SSR) is a comprehensive document submitted to NAAC describing the college's academic and administrative activities, achievements, and areas for improvement. Below are the available SSR documents:</p>
                <div style={{ marginTop: '1rem' }}>
                    <p style={noteStyle}>📌 SSR documents will be uploaded by the IQAC Coordinator. Contact <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a> for the latest SSR document.</p>
                </div>
                <div className="ext-links">
                    <a href="https://www.naac.gov.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 NAAC Portal</a>
                </div>
            </div>
        }
    />;
}

// ── Certification
export function IQACCertification() {
    return <IQACPage
        title="NAAC Certification"
        breadcrumb="Certification"
        subtitle="NAAC accreditation certificates and quality awards."
        content={
            <div className="info-card">
                <h2>NAAC Accreditation</h2>
                <p>Shri Mulikadevi Mahavidyalaya, Nighoj is accredited by the <strong>National Assessment and Accreditation Council (NAAC)</strong> with a <strong>"B" Grade</strong>. This accreditation reflects the institution's commitment to quality higher education.</p>
                <p style={{ marginTop: '0.8rem' }}>Accreditation documents and certificates are maintained by the IQAC and are available for inspection at the college office.</p>
                <div className="ext-links">
                    <a href="https://www.naac.gov.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 NAAC Portal</a>
                </div>
            </div>
        }
    />;
}

// ── Best Practices
export function IQACBestPractices() {
    const practices = [
        { title: 'Seed Bank Initiative', desc: 'Unique seed bank to promote agricultural awareness and conservation among students and the local community.' },
        { title: 'Competitive Exam Guidance Center', desc: 'Free coaching for MPSC, UPSC, and banking exams for rural students.' },
        { title: 'Tree Plantation Drive', desc: 'Annual plantation of 100+ trees on campus and in the nearby village as an eco-conservation initiative.' },
        { title: 'Student Counselling Cell', desc: 'Regular counselling sessions for academic, career, and personal development guidance.' },
    ];
    return <IQACPage
        title="Best Practices & Distinctiveness"
        breadcrumb="Best Practices"
        subtitle="Innovative practices that distinguish our institution."
        content={
            <div>
                <div className="cards-grid">
                    {practices.map(p => (
                        <div className="grid-card" key={p.title}>
                            <h3>{p.title}</h3>
                            <p>{p.desc}</p>
                        </div>
                    ))}
                </div>
                <div className="info-card" style={{ marginTop: '1.5rem' }}>
                    <h2>Institutional Distinctiveness</h2>
                    <p>The college serves a predominantly rural student catchment area in Parner taluka, Ahmednagar. Its commitment to affordable quality education and unique community-engagement programs make it a model institution for rural Maharashtra.</p>
                </div>
            </div>
        }
    />;
}

// ── Seminars
export function IQACSeminars() {
    const events = [
        { title: 'National Seminar on Environmental Conservation', date: '2023', type: 'Seminar' },
        { title: 'Workshop on Research Methodology', date: '2022', type: 'Workshop' },
        { title: 'Conference on Rural Development', date: '2022', type: 'Conference' },
        { title: 'FDP — ICT in Higher Education', date: '2021', type: 'Faculty Development' },
    ];
    return <IQACPage
        title="Seminars / Conferences / Workshops"
        breadcrumb="Seminars"
        subtitle="Academic events organized and participated in by the college."
        content={
            <div className="info-card">
                <h2>Recent Events</h2>
                <table className="data-table">
                    <thead><tr><th>Title</th><th>Year</th><th>Type</th></tr></thead>
                    <tbody>{events.map((e, i) => <tr key={i}><td style={{ fontWeight: 600 }}>{e.title}</td><td>{e.date}</td><td>{e.type}</td></tr>)}</tbody>
                </table>
            </div>
        }
    />;
}

// ── Extension Activity
export function IQACExtensionActivity() {
    return <IQACPage
        title="Extension Activity"
        breadcrumb="Extension Activity"
        subtitle="Community outreach and social service activities."
        content={
            <div className="info-card">
                <h2>Extension Activities</h2>
                <ul>
                    <li><strong>NSS Activities</strong> — Blood donation camps, village cleanliness drives, health awareness camps.</li>
                    <li><strong>Competitive Exam Guidance</strong> — Free guidance for rural students for MPSC/UPSC examinations.</li>
                    <li><strong>Rural Development Projects</strong> — Student-led initiatives for farmers and rural households.</li>
                    <li><strong>Environment Awareness</strong> — Plantation drives and eco-awareness campaigns in local schools and villages.</li>
                    <li><strong>Women Empowerment Programs</strong> — Workshops on self-defence, legal rights, and career opportunities for women students.</li>
                </ul>
            </div>
        }
    />;
}

// ── Capacity Building
export function IQACCapacityBuilding() {
    return <IQACPage
        title="Capacity Building & Skills Enhancement"
        breadcrumb="Capacity Building"
        subtitle="Programs to enhance student and faculty competencies."
        content={
            <div>
                <div className="info-card">
                    <h2>Student Capacity Building</h2>
                    <ul>
                        <li>Soft skills and communication workshops.</li>
                        <li>Certificate courses in computer applications.</li>
                        <li>Competitive examination coaching center.</li>
                        <li>Career counselling and placement preparation sessions.</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>Faculty Development</h2>
                    <ul>
                        <li>Faculty Development Programs (FDPs) on ICT tools and research.</li>
                        <li>Orientation and refresher courses through Academic Staff Colleges.</li>
                        <li>Encouragement of faculty research publications and minor research projects.</li>
                    </ul>
                </div>
            </div>
        }
    />;
}

export default IQACSSR;
